import { render, staticRenderFns } from "./UiTable.vue?vue&type=template&id=7531486a&scoped=true"
import script from "./UiTable.vue?vue&type=script&lang=js"
export * from "./UiTable.vue?vue&type=script&lang=js"
import style0 from "./UiTable.vue?vue&type=style&index=0&id=7531486a&prod&scoped=true&lang=css"
import style1 from "./UiTable.vue?vue&type=style&index=1&id=7531486a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531486a",
  null
  
)

export default component.exports